/*
 * File: index.tsx
 * Desc: 权限池，汇集权限数据源
 * File Created: 2019-09-29 10:53:24
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';
import { useAlitaState } from 'redux-alita';

type AuthPoolProps = {
    checkPermit: (permits: any) => React.ReactElement | null;
};

/** 权限池，汇集权限数据源 */
const AuthPool = (props: AuthPoolProps) => {
    const { permits } = useAlitaState([{ permits: [] }]);
    return props.checkPermit(permits.data);
};

export default AuthPool;
